export type ActiveModule = {
  current: "PARHATO2" | "CORE" | "4TIME" | "IRSKOM";
  isModuleInitialized: boolean;
};

const getActiveModule = (): ActiveModule => {
  const storedValue = localStorage.getItem("active-module");
  const activeModuleFromEnv = process.env.REACT_APP_ACTIVE_MODULE as ActiveModule["current"];

  if (!storedValue || activeModuleFromEnv === "4TIME" || activeModuleFromEnv === "IRSKOM") {
    return {
      current: activeModuleFromEnv,
      isModuleInitialized: true,
    };
  }

  try {
    const parsed = JSON.parse(storedValue);
    return parsed;
  } catch {
    // Value is not a JSON object
    return {
      current: storedValue as "PARHATO2" | "CORE" | "4TIME" | "IRSKOM",
      isModuleInitialized: false,
    };
  }
};

export const setActiveModule = (module: ActiveModule) => {
  localStorage.setItem("active-module", JSON.stringify(module));
};

export const activeModule = getActiveModule().current;
export const isModuleInitializedActiveModule = getActiveModule().isModuleInitialized;
